import { Component, OnInit, Input, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { stratificationModel, questionStratification, StraAdditional } from 'src/app/model/demographics.model';
import { AdminService } from 'src/services/admin.service';
import { questionModel, bindingModel } from 'src/models/question.model';
import { questionstudyModel, studyQuestionModel } from 'src/models/questionstudy.model';
import { Router } from '@angular/router';
import { RoundPipe } from 'src/app/admin/round.pipe';
import { DataService } from 'src/services/data.service';
import { sessionData } from 'src/models/data.model';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ValidationLimits, DynamicFieldNames } from 'src/app/Constant';
import { UserAccessService,UserModel } from 'src/services/useraccess.service';
import { Role } from 'src/Utilities/enum';
import { SHARED_IMPORTS } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-admindemographics',
  templateUrl: './admin_demographic_list.component.html',
  styleUrls: ['./admin_demographic_list.component.css'],
  standalone: true,
  imports: [...SHARED_IMPORTS]
})
export class AdminDemographicsComponent implements OnInit, OnChanges {
  isBetween: boolean;
  @Input() isEditable: string;
  @Input() studyId: number;
  @Input() disabled: boolean;
  public qModel: questionModel[];
  public qsModel: questionstudyModel;
  public qsDemographicsModel: any[];
  public qBind: bindingModel[] = [];
  public stratificationModel: stratificationModel[] = [];
  public DynamicModel: StraAdditional[] = [];
  public strmodel: stratificationModel[] = [];
  public objstratificationModel: stratificationModel = new stratificationModel();
  public stratificationNo: number = 0;
  public ageId: number;
  public weightId: number;
  public bmiId: number;
  public genderId: number;
  public testId: number;
  public ss: number = 0;
  public FromValueValidate: number;
  public ToValueValidate: number;
  public IsValid: boolean = true;
  public IsValidName: string;
  public IsValidStrNo: number;
  public CheckItem: StraAdditional = new StraAdditional;
  public itemname: string;
  public ageValidationFlag: boolean = true;
  public weightValidationFlag: boolean = true;
  public bmiValidationFlag: boolean = true;
  public questionLists: questionStratification[];
  public sessionData: sessionData;
  public qsModelArray: questionstudyModel[] = [];
  public toppingList: string[];
  customStratificationEnabled = false;
  form!: FormGroup;
  isLoading = false;
  isDeleting = false;
  isDeletingStrat = false;
  GridDisabled: boolean = false;
  AddStratificationVisible: boolean = false;
  SaveButtonVisible: boolean = false;
  public roleId: number;
  private loadedStudyId: number = 0;

  public ageError: Map<number, boolean> = new Map();
  public weightError: Map<number, boolean> = new Map();
  public upperArmError: Map<number, boolean> = new Map();
  public waistError: Map<number, boolean> = new Map();
  public wristError: Map<number, boolean> = new Map();
  public fastingBloodSugarError: Map<number, boolean> = new Map();
  public a1cError: Map<number, boolean> = new Map();
  public ahiError: Map<number, boolean> = new Map();

  public get questionCategory(): string {
    return "Demographics";
  }
  printObj: Object;

  constructor(private admin: AdminService, private router: Router, private cdr: ChangeDetectorRef,
    private dataService: DataService, private userAccessService: UserAccessService, private fb: FormBuilder) {
    this.qsModel = new questionstudyModel();
    this.qsModelArray = [];
    this.qsModel.question = new questionModel();
    this.qsModel.studyQuestion = new studyQuestionModel();
    this.qsModel.answer = [];
    this.CheckItem = null;
    this.form = this.fb.group({
      selectedOption: new FormControl({ value: '1', disabled: this.GridDisabled })
    });
  }

  filterPipe = new RoundPipe();
  userId: string;
  ngOnInit() {
    this.getMasterValues();

    this.userAccessService.userAccessData$.subscribe((userAccessData: UserModel[] | null) => {
      if (userAccessData && userAccessData.length > 0) {
        this.roleId = userAccessData[0].RoleId;
      }
    });
    this.GridDisabled = !(this.roleId === Role.Administrator || this.roleId === Role.ProjectManager);
    this.AddStratificationVisible = this.roleId === Role.Administrator || this.roleId === Role.ProjectManager;
    this.SaveButtonVisible = this.roleId === Role.Administrator || this.roleId === Role.ProjectManager;
    this.syncSelectedOptionState();
  }

  private syncSelectedOptionState(): void {
    const selectedOptionControl = this.form?.get('selectedOption');
    if (!selectedOptionControl) {
      return;
    }

    if (this.GridDisabled) {
      selectedOptionControl.disable({ emitEvent: false });
    } else {
      selectedOptionControl.enable({ emitEvent: false });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['studyId']) {
      this.loadStudySpecificData();
    }
  }

  private loadStudySpecificData(forceReload: boolean = false): void {
    const currentStudyId = Number(this.studyId);

    if (!Number.isFinite(currentStudyId) || currentStudyId <= 0) {
      this.loadedStudyId = 0;
      this.stratificationModel = [];
      this.DynamicModel = [];
      this.stratificationNo = 0;
      return;
    }

    if (!forceReload && this.loadedStudyId === currentStudyId) {
      return;
    }

    this.loadedStudyId = currentStudyId;
    this.getDemographicsQuestions();
    this.getDemoGraphicDynamicValues();
  } 

  getMasterValues() {
    this.admin.getMasterValuesforCombo().subscribe(res => {
      this.toppingList = res;
    });
  }

  getDemographicsQuestions() {
    this.admin.getStratificationQuestions().subscribe(res => {
      this.questionLists = res;
      this.ageId = this.questionLists.filter(x => x.questionText == "Age")[0].questionId;
      this.weightId = this.questionLists.filter(x => x.questionText == "Weight")[0].questionId;
      this.genderId = this.questionLists.filter(x => x.questionText == "Gender")[0].questionId;
      this.bmiId = this.questionLists.filter(x => x.questionText == "BMI")[0].questionId;
      this.getQSDemographics();
    });
  }

  getQSDemographics() {
    this.admin.getQSDemographics(this.loadedStudyId)
      .subscribe(res => {
        Promise.resolve().then(() => {
          res.forEach(b => {
            b.groupId = b.groupId == null ? 1 : b.groupId;
            if (b.answer1Id > 0) {
              if (b.questionText != 'Gender') {
                b.answer1 = this.filterPipe.transform(Number.parseFloat(b.answer1)).toString();
                b.answer2 = this.filterPipe.transform(Number.parseFloat(b.answer2)).toString();
              }
              b.includeCondition = true;
            }
            else b.answerType = "Text";
          });

          this.qBind = res.sort((a, b) => a.groupId - b.groupId);
          let groupId = Array.from(new Set(res.map(item => item.groupId))).sort((a, b) => a - b);

          this.stratificationModel = [];
          this.stratificationNo = 0;

          if (groupId.length == 0) {
            this.stratificationNo = this.stratificationNo + 1;
            this.stratificationModel.push(
              {
                sno: this.stratificationNo, studyId: null, questionText: null,
                ageQuestionId: null, ageAnswerType: null, ageFrom: null, ageTo: null, ageFromId: null, ageToId: null,
                weightQuestionId: null, weightAnswerType: null, weightFrom: null, weightTo: null, weightFromId: null, weightToId: null,
                bmiQuestionId: null, bmiAnswerType: null, bmiFrom: null, bmiTo: null, bmiFromId: null, bmiToId: null,
                genderQuestionId: null, genderAnswerType: null, male: false, female: false, genderId: null, stGroup: null,
                ageValidate: true, weightValidate: true, bmiValidate: true
              });
          }
          for (let k = 0; k < groupId.length; k++) {
            this.stratificationNo = this.stratificationNo + 1;
            this.stratificationModel.push({
              sno: this.stratificationNo, studyId: null, questionText: null,
              ageQuestionId: null, ageAnswerType: null, ageFrom: null, ageTo: null, ageFromId: null, ageToId: null,
              weightQuestionId: null, weightAnswerType: null, weightFrom: null, weightTo: null, weightFromId: null, weightToId: null,
              bmiQuestionId: null, bmiAnswerType: null, bmiFrom: null, bmiTo: null, bmiFromId: null, bmiToId: null,
              genderQuestionId: null, genderAnswerType: null, male: false, female: false, genderId: null, stGroup: groupId[k],
              ageValidate: true, weightValidate: true, bmiValidate: true
            });

            let stratificationList = this.qBind.filter(x => x.groupId === groupId[k]);

            for (let l = 0; l < stratificationList.length; l++) {
              let stratItem = stratificationList[l];
              let currentStrat = this.stratificationModel[k];

              currentStrat.questionText = stratItem.questionText;
              currentStrat.stGroup = stratItem.groupId;

              stratItem.answer1 = stratItem.answer1 == "-999" ? null : stratItem.answer1;
              stratItem.answer1 = stratItem.answer1 == "999" ? null : stratItem.answer1;
              stratItem.answer2 = stratItem.answer2 == "999" ? null : stratItem.answer2;

              switch (stratItem.questionText) {
                case "Age":
                  this.stratificationModel[k].ageQuestionId = stratificationList[l].questionId;
                  this.stratificationModel[k].ageAnswerType = stratificationList[l].questionText;
                  if (stratificationList[l].answer1 != null && stratificationList[l].answer1.toLowerCase() != 'null') {
                    this.stratificationModel[k].ageFrom = Number.parseFloat(stratificationList[l].answer1);
                    this.stratificationModel[k].ageFromId = stratificationList[l].answer1Id;
                  }
                  if (stratificationList[l].answer2 != null && stratificationList[l].answer2.toLowerCase() != 'null') {
                    this.stratificationModel[k].ageTo = Number.parseFloat(stratificationList[l].answer2)
                    this.stratificationModel[k].ageToId = stratificationList[l].answer2Id;
                  }
                  break;
                case "Weight":
                  this.stratificationModel[k].weightQuestionId = stratificationList[l].questionId;
                  this.stratificationModel[k].weightAnswerType = stratificationList[l].questionText;
                  if (stratificationList[l].answer1 != null && stratificationList[l].answer1.toLowerCase() != 'null') {
                    this.stratificationModel[k].weightFrom = Number.parseFloat(stratificationList[l].answer1)
                    this.stratificationModel[k].weightFromId = stratificationList[l].answer1Id;
                  }
                  if (stratificationList[l].answer2 != null && stratificationList[l].answer2.toLowerCase() != 'null') {
                    this.stratificationModel[k].weightTo = Number.parseFloat(stratificationList[l].answer2)
                    this.stratificationModel[k].weightFromId = stratificationList[l].answer2Id;
                  }
                  break;
                case "BMI":
                  this.stratificationModel[k].bmiQuestionId = stratificationList[l].questionId;
                  this.stratificationModel[k].bmiAnswerType = stratificationList[l].questionText;
                  if (stratificationList[l].answer1 != null && stratificationList[l].answer1.toLowerCase() != 'null') {
                    this.stratificationModel[k].bmiFrom = Number.parseFloat(stratificationList[l].answer1)
                    this.stratificationModel[k].bmiFromId = stratificationList[l].answer1Id;
                  }
                  if (stratificationList[l].answer2 != null && stratificationList[l].answer2.toLowerCase() != 'null') {
                    this.stratificationModel[k].bmiTo = Number.parseFloat(stratificationList[l].answer2)
                    this.stratificationModel[k].bmiFromId = stratificationList[l].answer2Id;
                  }
                  break;
                case "Gender":
                  this.stratificationModel[k].genderQuestionId = stratificationList[l].questionId;
                  this.stratificationModel[k].genderAnswerType = stratificationList[l].questionText;
                  if (stratificationList[l].answer1 != null && stratificationList[l].answer1.toLowerCase() != 'null') {
                    if (stratificationList[l].answer1 == "M")
                      this.stratificationModel[k].male = true
                    if (stratificationList[l].answer1 == "F")
                      this.stratificationModel[k].female = true
                    if (stratificationList[l].answer1 == "B") {
                      this.stratificationModel[k].male = true
                      this.stratificationModel[k].female = true
                    }
                    this.stratificationModel[k].genderId = stratificationList[l].answer1Id;
                  }
                  break;
              }
            }
          }
          this.cdr.markForCheck();
        });
      });
  }
  refactorGroupIds(list: any[]): any[] {
    let groupIdMap: { [key: number]: number } = {};
    let newGroupId = 1;

    list.forEach(item => {
      if (!groupIdMap[item.groupId]) {
        groupIdMap[item.groupId] = newGroupId++;
      }
      item.groupId = groupIdMap[item.groupId];
    });
    return list;
  }

  refactorDynamicGroupNo(list: any[]): any[] {
    let grpNoMap: { [key: number]: number } = {};
    let strNoMap: { [key: number]: number } = {};
    let newGroupId = 1;
    let newStrNo = 1;

    list.forEach(item => {
      if (!grpNoMap[item.grpNo]) {
        grpNoMap[item.grpNo] = newGroupId++;
      }
      if (!strNoMap[item.strno]) {
        strNoMap[item.strno] = newStrNo++;
      }
      item.grpNo = grpNoMap[item.grpNo];
      item.strno = strNoMap[item.strno];
    });
    return list;
  }

  refactorStratificationModel(list: stratificationModel[]): { refactoredList: stratificationModel[], groupMap: Map<number, number>, snoMap: Map<number, number> } {
    let grpNoMap: { [key: number]: number } = {};
    let strNoMap: { [key: number]: number } = {};
    let newGroupId = 1;
    let newStrNo = 1;

    list.forEach(item => {
      if (!grpNoMap[item.stGroup]) {
        grpNoMap[item.stGroup] = newGroupId++;
      }
      if (!strNoMap[item.sno]) {
        strNoMap[item.sno] = newStrNo++;
      }
      item.stGroup = grpNoMap[item.stGroup];
      item.sno = strNoMap[item.sno];
    });

    let groupMap = new Map<number, number>();
    let snoMap = new Map<number, number>();

    Object.entries(grpNoMap).forEach(([oldGrp, newGrp]) => {
      groupMap.set(Number(oldGrp), newGrp);
    });

    Object.entries(strNoMap).forEach(([oldSno, newSno]) => {
      snoMap.set(Number(oldSno), newSno);
    });

    return { refactoredList: list, groupMap, snoMap };
  }

  removeStratification(rowNumber, sno) {
    this.isDeletingStrat = true;
    let deleteIndex = this.stratificationModel.findIndex(x => x.sno === sno);
    if (deleteIndex === -1) {
      this.isDeletingStrat = false;
      return;
    }
    this.stratificationModel = this.stratificationModel.filter(x => x.sno !== sno);

    let newSno = 1;
    let groupMap = new Map<number, number>();
    this.stratificationModel.forEach((strat, index) => {
      let oldGroupId = strat.stGroup;
      strat.sno = newSno;
      strat.stGroup = newSno;
      groupMap.set(oldGroupId, newSno);
      newSno++;
    });
    this.stratificationNo = this.stratificationModel.length;
    this.DynamicModel = this.DynamicModel.filter(dyn => dyn.strno !== sno);
    this.DynamicModel.forEach(dyn => {
      if (groupMap.has(dyn.grpNo)) {
        dyn.grpNo = groupMap.get(dyn.grpNo);
      }
      let newStrat = this.stratificationModel.find(s => s.stGroup === dyn.grpNo);
      if (newStrat) {
        dyn.strno = newStrat.sno;
      }
    });

    this.isDeletingStrat = false;

    if (this.stratificationModel.length === 0) {
      this.stratificationNo = 1;
      this.stratificationModel.push({
        sno: this.stratificationNo, studyId: null, questionText: null,
        ageQuestionId: null, ageAnswerType: null, ageFrom: null, ageTo: null, ageFromId: null, ageToId: null,
        weightQuestionId: null, weightAnswerType: null, weightFrom: null, weightTo: null, weightFromId: null, weightToId: null,
        bmiQuestionId: null, bmiAnswerType: null, bmiFrom: null, bmiTo: null, bmiFromId: null, bmiToId: null,
        genderQuestionId: null, genderAnswerType: null, male: false, female: false, genderId: null, stGroup: this.stratificationNo,
        ageValidate: true, weightValidate: true, bmiValidate: true
      });
    }
  }

  removeAdditionalInfo(stno, itemname) {
    this.isDeleting = true;
    let index = this.DynamicModel.findIndex(x => x.PrName === itemname && x.strno === stno);
    if (index !== -1) {
      this.DynamicModel.splice(index, 1);
    }
    this.isDeleting = false;
    this.form.get('selectedOption').setValue('1');
  }

  saveStratification() {
    if (this.hasValidationErrors()) {
      this.isLoading = false;
      alert('Please correct validation errors before saving!');
      return;
    }

    this.isLoading = true;
    this.addQuestionStudy();
  }

  hasValidationErrors(): boolean {
    for (let [sno, hasError] of this.ageError) {
      if (hasError) return true;
    }

    for (let [sno, hasError] of this.weightError) {
      if (hasError) return true;
    }

    let dynamicFieldErrors = [
      this.upperArmError, this.waistError, this.wristError,
      this.fastingBloodSugarError, this.a1cError, this.ahiError
    ];

    for (let errorMap of dynamicFieldErrors) {
      for (let [sno, hasError] of errorMap) {
        if (hasError) return true;
      }
    }

    return false;
  }

  SaveDynamicFields() {
    let stratQuestionOrder = 1;
    let stratificationName = "";
    this.DynamicModel.forEach((v, i) => {
      stratificationName = v.PrName
      if (stratificationName.includes("inches")) {
         v.PrName = this.removeParenthesizedText(stratificationName);
      }
      v.stratificationQuestionOrder = stratQuestionOrder++
      if (v.grpNo == null) {
        let m = 1;
        this.stratificationModel.forEach((k, l) => {
          if (v.strno == k.sno) { v.grpNo = m; }
          m = m + 1;
        });
      }
      else {
        this.ss = v.grpNo;
      }
      if (String(v.fromValue) == "") {
        v.fromValue = null;
      }
      if (String(v.toValue) == "") {
        v.toValue = null;
      }
    });
    this.admin.postUpdateDynamicStratification(this.DynamicModel)
      .subscribe(res => {
        this.isLoading = false;
        this.refreshStratification();
        alert('Record saved Successfully');
      });
  }

  addQuestionStudy() {
    let isValid = true;
    this.sessionData = this.dataService.getData();
    if (this.studyId == null) {
      this.studyId = this.sessionData.studyId;
    }
    if (this.studyId.toString() == "" || this.studyId.toString() == 'NaN') {
      this.studyId = this.sessionData.studyId;
    }
    if (this.studyId == undefined) {
      this.isLoading = false;
      alert("Study not created. Study details required.");
      return false;
    }
    if (this.studyId == null) {
      this.isLoading = false;
      alert("Study not created. Study details required.");
      return false;
    }
    if (this.studyId.toString() == "") {
      this.isLoading = false;
      alert("Study not created. Study details required.");
      return false;
    }
    if (this.studyId.toString() == 'NaN') {
      this.isLoading = false;
      alert("Study not created. Study details required.");
      return false;
    }

    this.stratificationModel.forEach((v, i) => {
      if (v.ageValidate == false || v.weightValidate == false || v.bmiValidate == false) {
        isValid = false;
      }
    });

    let genderVal = true;
    this.stratificationModel.forEach((v, i) => {
      if (v.male == false && v.female == false) {
        genderVal = false;
      }
    });
    if (!genderVal) {
      this.isLoading = false;
      alert('Please select gender!');
      return false;
    }
    if (!isValid) {
      this.isLoading = false;
      alert('Invalid answer provided!');
      return false;
    }
    if (!this.IsValid) {
      this.isLoading = false;
      alert('Invalid answer provided!');
      return false;
    }

    let stGroupId = Math.max.apply(Math, this.stratificationModel.map(function (o) { return o.stGroup; }));
    let validationFlag = false;

    this.stratificationModel.forEach((v, i) => {
      if (v.ageFrom != null || v.ageTo != null || v.weightFrom != null || v.weightTo != null || v.bmiFrom != null || v.bmiTo != null || v.male == true || v.female == true) {
        validationFlag = true;
      }
      let grpId = 0;
      if (v.stGroup != null && v.stGroup != 0) {
        grpId = v.stGroup;
      }
      else {
        grpId = stGroupId + 1;
        stGroupId = stGroupId + 1;
      }
      if ((v.ageFrom != null || v.ageTo != null)) {
        this.insertStratification(this.ageId, "Age", "Age", v.ageFromId, v.ageToId, v.ageFrom, v.ageTo, grpId);
      }
      if ((v.weightFrom != null || v.weightTo != null)) {
        this.insertStratification(this.weightId, "Weight", "Weight", v.weightFromId, v.weightToId, v.weightFrom, v.weightTo, grpId)
      }
      if ((v.bmiFrom != null || v.bmiTo != null)) {
        this.insertStratification(this.bmiId, "BMI", "BMI", v.bmiFromId, v.bmiToId, v.bmiFrom, v.bmiTo, grpId)
      }
      if ((v.male == true || v.female == true)) {
        let gender = v.male == true && v.female == true ? 'B' : v.male == true ? 'M' : v.female == true ? 'F' : '';
        this.insertStratification(this.genderId, "Gender", "Gender", v.genderId, 0, gender, 0, grpId)
      }
      if (v.genderId > 0 && v.male == false && v.female == false) {
        this.admin.deleteQuestionStratification(this.genderId, this.studyId, grpId)
          .subscribe(r => { });
      }
    });
    if (!validationFlag) {
      this.isLoading = false;
      alert("No details entered!")
      return false;
    }
    this.admin.postUpdateQSgroup(this.qsModelArray)
      .subscribe(res => {
        this.qsModelArray = [];
        this.SaveDynamicFields();
      });
  }
  insertStratification(questionId, questionText, answerType, answer1Id, answer2Id, answer1, answer2, stGroup) {
    this.qsModel = new questionstudyModel();
    this.qsModel.question = new questionModel();
    this.qsModel.studyQuestion = new studyQuestionModel();
    this.qsModel.answer = [];
    answer1 = answer1 == "" ? null : answer1;
    answer2 = answer2 == "" ? null : answer2;
    if ((answer1Id > 0 && answer1 == null && answer2 == null)) {
      this.admin.deleteQS(questionId, this.studyId)
        .subscribe(r => { });
    }
    else {
      answer1 = answer1 == null ? -999 : answer1;
      answer2 = answer2 == null ? 999 : answer2;
      this.qsModel.question.questionId = questionId;
      this.qsModel.question.questionText = questionText;
      this.qsModel.question.toolTip = "NA";
      this.qsModel.question.questionCategory = this.questionCategory;
      this.qsModel.studyQuestion.studyId = this.studyId;
      this.qsModel.studyQuestion.questionOrder = 0;
      this.qsModel.studyQuestion.isPrescreener = false;
      this.qsModel.studyQuestion.isActive = true;
      this.qsModel.question.answerType = answerType;
      this.qsModel.studyQuestion.stGroup = stGroup;
      if (answer1Id > 0 && answer2Id > 0) {
        this.qsModel.answer.push({
          answerId: answer1Id, answerText: answer1, isCorrect: false, isActive: true
        });
        if (questionText != "Gender") {
          this.qsModel.answer.push({
            answerId: answer2Id, answerText: answer2, isCorrect: false, isActive: true
          });
        }
      }
      else if (answer1Id > 0 && (answer2Id == null || answer2Id == 0)) {
        this.qsModel.answer.push({
          answerId: answer1Id, answerText: answer1, isCorrect: false, isActive: true
        });
        if (questionText != "Gender") {
          this.qsModel.answer.push({
            answerId: null, answerText: answer2, isCorrect: false, isActive: true
          });
        }
      }
      else {
        this.qsModel.answer.push({
          answerId: 0, answerText: answer1, isCorrect: false, isActive: true
        });
        if (questionText != "Gender") {
          this.qsModel.answer.push({
            answerId: 0, answerText: answer2, isCorrect: false, isActive: true
          });
        }
      }
      this.qsModelArray.push(this.qsModel);
    }
  }
  numberOnly(event) {
    event = (event) ? event : window.event;
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && charCode != 46 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    if (Number.parseInt(event.target.value) > 999) {
      return false;
    }
    return true;
  }
  addStratification() {
    this.stratificationNo = this.stratificationNo + 1;
    this.stratificationModel.push(
      {
        sno: this.stratificationNo, studyId: null, questionText: null,
        ageQuestionId: null, ageAnswerType: null, ageFrom: null, ageTo: null, ageFromId: null, ageToId: null,
        weightQuestionId: null, weightAnswerType: null, weightFrom: null, weightTo: null, weightFromId: null, weightToId: null,
        bmiQuestionId: null, bmiAnswerType: null, bmiFrom: null, bmiTo: null, bmiFromId: null, bmiToId: null,
        genderQuestionId: null, genderAnswerType: null, male: false, female: false, genderId: null, stGroup: null,
        ageValidate: true, weightValidate: true, bmiValidate: true
      }
    );
  }
  getDemoGraphicDynamicValues() {
    this.admin.getDemographicDynamicValues(this.loadedStudyId)
      .subscribe(res => {
          this.DynamicModel = res;
          this.cdr.detectChanges();
      });
  }

  OnComboSelect(rowNumber, stno, topping, GrpNo) {
    let customStratValue = '2';
    if (topping.value != 1) {
      this.CheckItem = this.DynamicModel.find((x) => (x.PrName == topping.value && x.strno == stno)) || null

      if (this.CheckItem == null) {
        this.DynamicModel.push({
          strno: stno,
          studyId: this.studyId,
          PrName: topping.value,
          fromValue: null,
          toValue: null,
          questionId: null,
          answerFromId: null,
          answerToId: null,
          grpNo: GrpNo,
          customStrat: topping.value == 2,
          stratificationQuestionOrder: 0
        });
      }
      if (this.DynamicModel.filter(dyn => dyn.customStrat).length) {
        customStratValue = this.DynamicModel.filter(dyn => dyn.customStrat)[0].PrName;
      }
      this.DynamicModel = this.DynamicModel.sort((a, b) => {
        if (a.PrName == customStratValue) return 1;
        if (b.PrName == customStratValue) return -1;
        return 0;
      });
    }
    this.form.get('selectedOption').setValue('1');
  }

  validateAge(value: number, sno: number): boolean {
    if (value === null || value === undefined || value.toString() === '') {
      this.ageError.set(sno, false);
      return true;
    }

    let hasError = value > ValidationLimits.AGE_MAX;
    this.ageError.set(sno, hasError);
    return !hasError;
  }

  validateWeight(value: number, sno: number): boolean {
    if (value === null || value === undefined || value.toString() === '') {
      this.weightError.set(sno, false);
      return true;
    }

    let hasError = value < ValidationLimits.WEIGHT_MIN || value > ValidationLimits.WEIGHT_MAX;
    this.weightError.set(sno, hasError);
    return !hasError;
  }

  validateDynamicField(value: number, strno: number, fieldName: string): boolean {
    if (value === null || value === undefined || value.toString() === '') {
      this.clearDynamicFieldError(strno, fieldName);
      return true;
    }

    let hasError = false;
    let valueNum = Number(value);

    switch (fieldName) {
      case DynamicFieldNames.UPPER_ARM_CIRCUMFERENCE:
        hasError = valueNum < ValidationLimits.UPPER_ARM_MIN || valueNum > ValidationLimits.UPPER_ARM_MAX;
        this.upperArmError.set(strno, hasError);
        break;
      case DynamicFieldNames.WAIST_CIRCUMFERENCE:
        hasError = valueNum < ValidationLimits.WAIST_MIN || valueNum > ValidationLimits.WAIST_MAX;
        this.waistError.set(strno, hasError);
        break;
      case DynamicFieldNames.WRIST_CIRCUMFERENCE:
        hasError = valueNum < ValidationLimits.WRIST_MIN || valueNum > ValidationLimits.WRIST_MAX;
        this.wristError.set(strno, hasError);
        break;
      case DynamicFieldNames.FASTING_BLOOD_SUGAR:
        hasError = valueNum < ValidationLimits.FASTING_BLOOD_SUGAR_MIN || valueNum > ValidationLimits.FASTING_BLOOD_SUGAR_MAX;
        this.fastingBloodSugarError.set(strno, hasError);
        break;
      case DynamicFieldNames.A1C_WITHIN_LAST_6_MONTHS:
        hasError = valueNum < ValidationLimits.A1C_MIN || valueNum > ValidationLimits.A1C_MAX;
        this.a1cError.set(strno, hasError);
        break;
      case DynamicFieldNames.AHI_SCORE_FROM_SLEEP_STUDY:
        hasError = valueNum > ValidationLimits.AHI_MAX;
        this.ahiError.set(strno, hasError);
        break;
    }

    return !hasError;
  }

  clearDynamicFieldError(strno: number, fieldName: string): void {
    switch (fieldName) {
      case DynamicFieldNames.UPPER_ARM_CIRCUMFERENCE:
        this.upperArmError.set(strno, false);
        break;
      case DynamicFieldNames.WAIST_CIRCUMFERENCE:
        this.waistError.set(strno, false);
        break;
      case DynamicFieldNames.WRIST_CIRCUMFERENCE:
        this.wristError.set(strno, false);
        break;
      case DynamicFieldNames.FASTING_BLOOD_SUGAR:
        this.fastingBloodSugarError.set(strno, false);
        break;
      case DynamicFieldNames.A1C_WITHIN_LAST_6_MONTHS:
        this.a1cError.set(strno, false);
        break;
      case DynamicFieldNames.AHI_SCORE_FROM_SLEEP_STUDY:
        this.ahiError.set(strno, false);
        break;
    }
  }

  checkAgeFrom(sno) {
    let tempStrat_Model = this.stratificationModel.filter(x => x.sno == sno)[0];
    let fromValid = this.validateAge(tempStrat_Model.ageFrom, sno);
    let toValid = this.validateAge(tempStrat_Model.ageTo, sno);
    this.ageError.set(sno, !(fromValid && toValid));
  }

  checkAgeTo(sno) {
    let tempStrat_Model = this.stratificationModel.filter(x => x.sno == sno)[0];
    let fromValid = this.validateAge(tempStrat_Model.ageFrom, sno);
    let toValid = this.validateAge(tempStrat_Model.ageTo, sno);
    this.ageError.set(sno, !(fromValid && toValid));
  }

  checkWeightFrom(sno) {
    let tempStrat_Model = this.stratificationModel.filter(x => x.sno == sno)[0];
    let fromValid = this.validateWeight(tempStrat_Model.weightFrom, sno);
    let toValid = this.validateWeight(tempStrat_Model.weightTo, sno);
    this.weightError.set(sno, !(fromValid && toValid));
  }

  checkWeightTo(sno) {
    let tempStrat_Model = this.stratificationModel.filter(x => x.sno == sno)[0];
    let fromValid = this.validateWeight(tempStrat_Model.weightFrom, sno);
    let toValid = this.validateWeight(tempStrat_Model.weightTo, sno);
    this.weightError.set(sno, !(fromValid && toValid));
  }

  checkDynamicFrom(strno, prname) {
    let DyMdl = this.DynamicModel.find((x) => (x.PrName == prname && x.strno == strno)) || null;
    if (DyMdl) {
      let fromValid = this.validateDynamicField(Number(DyMdl.fromValue), strno, prname);
      let toValid = this.validateDynamicField(Number(DyMdl.toValue), strno, prname);
      this.setDynamicFieldError(strno, prname, !(fromValid && toValid));
    }
  }

  checkDynamicTo(strno, prname) {
    let DyMdl = this.DynamicModel.find((x) => (x.PrName == prname && x.strno == strno)) || null;
    if (DyMdl) {
      let fromValid = this.validateDynamicField(Number(DyMdl.fromValue), strno, prname);
      let toValid = this.validateDynamicField(Number(DyMdl.toValue), strno, prname);

      if (prname === DynamicFieldNames.AHI_SCORE_FROM_SLEEP_STUDY && Number(DyMdl.toValue) === ValidationLimits.AHI_MIN) {
        this.ahiError.set(strno, true);
      } else {
        this.setDynamicFieldError(strno, prname, !(fromValid && toValid));
      }
    }
  }

  setDynamicFieldError(strno: number, fieldName: string, hasError: boolean): void {
    switch (fieldName) {
      case DynamicFieldNames.UPPER_ARM_CIRCUMFERENCE:
        this.upperArmError.set(strno, hasError);
        break;
      case DynamicFieldNames.WAIST_CIRCUMFERENCE:
        this.waistError.set(strno, hasError);
        break;
      case DynamicFieldNames.WRIST_CIRCUMFERENCE:
        this.wristError.set(strno, hasError);
        break;
      case DynamicFieldNames.FASTING_BLOOD_SUGAR:
        this.fastingBloodSugarError.set(strno, hasError);
        break;
      case DynamicFieldNames.A1C_WITHIN_LAST_6_MONTHS:
        this.a1cError.set(strno, hasError);
        break;
      case DynamicFieldNames.AHI_SCORE_FROM_SLEEP_STUDY:
        this.ahiError.set(strno, hasError);
        break;
    }
  }

  checkMax(strno, prname) {
    let DyMdl = this.DynamicModel.find((x) => (x.PrName == prname && x.strno == strno)) || null;
    if (!DyMdl) return;

    this.FromValueValidate = DyMdl.fromValue;
    this.ToValueValidate = DyMdl.toValue;

    let fromValid = true;
    let toValid = true;

    if (this.FromValueValidate != null && this.FromValueValidate.toString() !== '') {
      fromValid = this.validateDynamicField(Number(this.FromValueValidate), strno, prname);
    }

    if (this.ToValueValidate != null && this.ToValueValidate.toString() !== '') {
      toValid = this.validateDynamicField(Number(this.ToValueValidate), strno, prname);
    }

    this.IsValid = fromValid && toValid;
    this.IsValidName = DyMdl.PrName;
    this.IsValidStrNo = strno;
  }

  checkAgeMax(sno) {
    let tempStrat_Model = this.stratificationModel.filter(x => x.sno == sno)[0];
    let itemIndex = this.stratificationModel.findIndex(item => item.sno == sno);

    let fromValid = this.validateAge(tempStrat_Model.ageFrom, sno);
    let toValid = this.validateAge(tempStrat_Model.ageTo, sno);

    this.ageError.set(sno, !(fromValid && toValid));
    this.stratificationModel[itemIndex].ageValidate = true;
    this.ageValidationFlag = fromValid && toValid;
  }

  checkWeightMax(sno) {
    let tempStrat_Model = this.stratificationModel.filter(x => x.sno == sno)[0];
    let itemIndex = this.stratificationModel.findIndex(item => item.sno == sno);

    let fromValid = this.validateWeight(tempStrat_Model.weightFrom, sno);
    let toValid = this.validateWeight(tempStrat_Model.weightTo, sno);

    this.weightError.set(sno, !(fromValid && toValid));
    this.stratificationModel[itemIndex].weightValidate = true;
    this.weightValidationFlag = fromValid && toValid;
  }

  checkBMIMax(sno) {
    let tempStrat_Model = this.stratificationModel.filter(x => x.sno == sno)[0];
    let itemIndex = this.stratificationModel.findIndex(item => item.sno == sno);

    this.stratificationModel[itemIndex].bmiValidate = true;
    this.bmiValidationFlag = true;
  }

  setCustomStratification(strat) {
    this.DynamicModel.forEach(obj => {
      if (obj.customStrat) {
        obj.PrName = strat;
      }
    });
  }

  refreshStratification() {
    this.stratificationModel = [];
    this.DynamicModel = [];
    this.stratificationNo = 0;
    this.getMasterValues();
    this.loadStudySpecificData(true);
  }
  private removeParenthesizedText(input: string): string {
    if (!input) return '';

    let depth = 0;
    let result = '';

    for (let i = 0; i < input.length; i++) {
      const ch = input[i];

      if (ch === '(') {
        depth++;
        continue;
      }

      if (ch === ')') {
        if (depth > 0) depth--;
        continue;
      }

      if (depth === 0) {
        result += ch;
      }
    }

    return result.trim();
  }

}
